module.exports = __webpack_public_path__ + "_assets/img/digital-card-icon.0f451a83.svg";